
namespace Nbs.Xlr8PageTemplate.Flyout {
  let activeMenuId: string | undefined;
  export let openFlyoutId: string | undefined;

  export const closeWait = 401;
  export const longOpenWait = 500;
  export const shortOpenWait = 10;
  export const filterWait = 350;

  export function reset() {
    openFlyoutId = undefined;
  }

  export function titleCheck() {
    const items = document.querySelectorAll('.xpt-flyout-menu-item-container .xpt-menu-link-label span');
    items.forEach((item) => {
      const span = item as HTMLElement;
      span.scrollHeight > span.clientHeight ?
        span.setAttribute('title', span.innerHTML) :
        span.removeAttribute('title');
    });
  }

  export function navigationClickHandler(menuItem: Navigation.Menu) {
    if (openFlyoutId) {
      if (openFlyoutId !== menuItem.id) {
        // a new flyout menu was clicked close existing and open the new one...
        setTimeout(() => { openFlyoutMenu(menuItem); }, longOpenWait);
      }
      closeFlyoutMenu();
    } else {
      // just open the flyout clicked...
      openFlyoutMenu(menuItem);
    }
  }

  function getFlyoutMenuElement(flyoutId: string) {
    document.body.appendChild(Utilities.createElement({
      attributes: { id: `xpt-flyout-backdrop-${flyoutId}` },
      classes: ['xpt-flyout-backdrop']
    }));

    const flyout = Utilities.createElement({
      tag: 'xpt-flyout-menu',
      attributes: { 'aria-labelledby': `xpt-flyout-menu-header-id-${flyoutId}`, id: `xpt-flyout-menu-${flyoutId}` }
    });

    const parent = document.querySelector<HTMLLIElement>(`li[data-menu-item-id="${flyoutId}"]`);
    parent?.appendChild(flyout);

    return flyout;
  }

  export function closeFlyoutHandler(event: Event) {
    if (openFlyoutId) {
      const flyout = (event.target as Element).closest('xpt-flyout-menu');
      if (!flyout) {
        closeFlyoutMenu();
      }
    }
  }

  export function closeFlyoutMenu() {
    const backdrop = document.querySelector(`#xpt-flyout-backdrop-${openFlyoutId}`);
    backdrop?.parentNode?.removeChild(backdrop);

    const flyout = document.querySelector(`#xpt-flyout-menu-${openFlyoutId}`)
    if (flyout) {
      flyout.classList.remove('xpt-flyout-open-width');
      flyout.innerHTML = '';

      setTimeout(() => { flyout?.parentNode?.removeChild(flyout); }, closeWait);
    }

    const nav = Menu.MenuDom.getMenuNavElement();
    nav?.classList.remove('xpt-flyout-open');

    // revert selected menu item...
    updateExpandedAttribute(Menu.getActiveMenuItem() ?? '', false);

    const currentActiveMenuId = Menu.getActiveMenuItem();
    if (activeMenuId && currentActiveMenuId === openFlyoutId) {
      Menu.setActiveMenuItem(activeMenuId);
    }
    openFlyoutId = undefined;
    Menu.MenuDom.disableTemporarilyFlyoutMenuItem();
  }

  export function openFlyoutMenu(menu: Navigation.Menu) {
    // get the current selected menu item...
    activeMenuId = Menu.getActiveMenuItem();
    Menu.setActiveMenuItem(menu.id);

    const flyout = getFlyoutMenuElement(menu.id);
    if (flyout) {
      flyout.appendChild(getFlyoutElement(menu));
      updateExpandedAttribute(menu.id, true);
      openFlyoutId = menu.id;
      setFlyoutHeight();
      setFlyoutTop();
      setTimeout(() => {
        flyout.classList.add('xpt-flyout-open-width');
        const nav = Menu.MenuDom.getMenuNavElement();
        nav?.classList.add('xpt-flyout-open');
      }, shortOpenWait);
    }
  }

  export function setFlyoutHeight() {
    if (openFlyoutId) {
      const container = document.querySelector<HTMLElement>('.xpt-flyout-container');
      if (container) {
        const scrollMargin = 20;
        const newHeight = window.innerHeight - Header.headerMenuHeight - scrollMargin - Header.getEnvironmentBannerMessageHeight();
        const style = `${newHeight}px`;
        container.style.height = style;

        const isVisible = !!(container.offsetWidth || container.offsetHeight || container.getClientRects().length);
        if (!isVisible) {
          closeFlyoutMenu();
        }
      }
    }
  }

  export function setFlyoutTop() {
    if (openFlyoutId) {
      const container = document.querySelector<HTMLElement>('xpt-flyout-menu');
      if (container) {
        const newTop = Header.getHeight();
        const style = `${newTop}px`;
        container.style.top = style;
      }
    }
  }

  function updateExpandedAttribute(menuId: string, expanded: boolean) {
    const parentLink = document.querySelector(`li[data-menu-item-id="${menuId}"] a`);
    if (parentLink) {
      parentLink.setAttribute('aria-expanded', expanded.toString());
    }
  }

  function toggleNodeExpansion(expander: HTMLElement) {
    const parent = expander.closest('li');
    if (parent) {
      const childList = parent.querySelector('ul');
      childList?.classList.toggle('xpt-display-none');
      expander.classList.toggle('xpt-flyout-node-expanded');
      const nodeLink = parent.querySelector('a');
      nodeLink?.setAttribute('aria-expanded', expander.classList.contains('xpt-flyout-node-expanded').toString());
    }
  }

  let filterCallback: NodeJS.Timer;
  function onSearch(value: string) {
    clearTimeout(filterCallback);
    filterCallback = setTimeout(() => filterTree(value), filterWait);
  }

  function filterTree(filter: string) {
    const nodeLabels = document.querySelectorAll('.xpt-flyout-container nav .xpt-flyout-menu-item span');
    const regex = new RegExp(escapeRegexPattern(filter), 'i');
    const parentNodes: HTMLElement[] = [];

    // hide any leaf nodes that fail the filter check...
    nodeLabels.forEach((label) => {
      const element = label as HTMLElement;
      const listItem = label.closest('li');
      if (listItem) {
        const isParent = !!listItem.querySelector('ul');
        if (isParent) {
          parentNodes.push(listItem);
        } else {
          const match = regex.exec(element.innerText);
          if (match) {
            listItem.classList.remove('xpt-display-none');
          } else {
            listItem.classList.add('xpt-display-none');
          }
        }
      }
    });

    // hide any parent nodes that have all children hidden and don't pass the filter check...
    parentNodes.reverse().forEach((item) => {
      const label = item.querySelector('span');
      const match = label?.innerText.match(regex);
      const visibleItems = item.querySelectorAll('li:not(.xpt-display-none)');
      if (!!match || visibleItems.length > 0) {
        item.classList.remove('xpt-display-none');
      } else {
        item.classList.add('xpt-display-none');
      }
    });

    // show/hide the empty result message...
    const flyoutMenu = document.querySelector('xpt-flyout-menu') as HTMLElement;
    const visibleCount = flyoutMenu.querySelectorAll('li:not(.xpt-display-none)').length;
    const emptyMsg = flyoutMenu.querySelector('.xpt-empty-search-msg') as HTMLElement;
    emptyMsg.classList.toggle('xpt-display-none', visibleCount > 0);
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
  function escapeRegexPattern(regexPattern: string) {
    return regexPattern.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
  }

  function getFlyoutElement(menu: Navigation.Menu) {
    // flyout heading and close button...
    const flyoutHeading = menu.desc ?? '';
    const flyoutHeaderElement = Utilities.createElement({
      classes: ['xpt-flyout-header'],
      children: [
        Utilities.createElement({
          tag: 'span',
          attributes: { id: `xpt-flyout-menu-header-id-${menu.id}`, role: 'heading', 'aria-level': 2 },
          children: [flyoutHeading]
        }),
        Utilities.createElement({
          tag: 'button',
          classes: ['xpt-flyout-close-button'],
          eventHandlers: {
            click: event => {
              closeFlyoutMenu();
              Utilities.stopEvent(event);
              return false;
            }
          },
          children: [Utilities.getIconElement('close', 'close menu')]
        })
      ]
    });

    // search input...
    const minNodeCount = 5;
    const nodeCount = countChildren(menu);
    let searchInputElements: readonly HTMLElement[];
    if (nodeCount > minNodeCount) {
      searchInputElements = [
        Utilities.createElement({
          classes: ['xpt-flyout-search'],
          children: [
            Utilities.createElement({
              tag: 'input',
              classes: ['xpt-flyout-search-input'],
              attributes: {
                'aria-label': 'Search',
                placeholder: 'Search',
                type: 'text'
              },
              eventHandlers: { input: e => onSearch((e.target as HTMLInputElement).value) }
            })
          ]
        }),
        Utilities.createElement({ classes: ['xpt-empty-search-msg', 'xpt-display-none'], children: ['No Matches Found'] })
      ];
    } else {
      searchInputElements = [];
    }

    // tree navigation...
    const navElement = Utilities.createElement({
      tag: 'nav',
      attributes: { 'aria-label': `${menu.label} Flyout Menu` },
      children: [menuToListElement(menu.childItems)]
    });

    return Utilities.createElement({
      classes: ['xpt-flyout-container'],
      children: [flyoutHeaderElement, ...searchInputElements, navElement]
    });
  }

  function menuToListElement(items: readonly Navigation.MenuItem[]): HTMLElement {
    return Utilities.createElement({
      tag: 'ul',
      attributes: { role: 'menu' },
      children: items.map(item => {
        const link = (item as Navigation.Link);
        const menu = (item as Navigation.Menu);

        const classes = ['xpt-flyout-menu-item-wrapper'];
        const attributes: Utilities.ElementBuilderAttributes = {
          role: 'menuitem'
        };
        if (link.isSelected) {
          classes.push('xpt-flyout-selected');
          attributes['aria-current'] = true;
        }
        if (link.isDisabled) {
          classes.push('xpt-flyout-disabled');
          attributes['aria-disabled'] = true;
        }

        const menuItemChildren = [Utilities.createElement({
          classes,
          children: [Utilities.createElement({
            tag: 'a',
            attributes: {
              'aria-disabled': link.isDisabled ? true : undefined,
              'aria-expanded': menu.childItems ? true : undefined,
              'data-menu-item-id': menu.id,
              href: link.isDisabled ? undefined : (link.url ?? '#'),
              id: `xpt-flyout-node-link-${menu.id}`,
              target: link.openInTab ? '_blank' : undefined,
              rel: link.openInTab ? 'noopener' : undefined,
              role: link.url ? 'button' : undefined,
            },
            eventHandlers: { click: Menu.onClick },
            children: [
              Utilities.createLinkLabelElement(link)
            ]
          })]
        })];

        if (menu.childItems) {
          menuItemChildren.push(Utilities.createElement({
            classes: ['xpt-flyout-menu-item-expander'],
            children: [
              Utilities.createElement({
                tag: 'a',
                classes: ['xpt-flyout-arrow', 'xpt-flyout-node-expanded'],
                attributes: {
                  'aria-labelledby': `xpt-flyout-node-expand-btn-${menu.id} xpt-flyout-node-link-${menu.id}`,
                  href: '#',
                  role: 'button',
                },
                eventHandlers: {
                  click: event => {
                    toggleNodeExpansion(event.target as HTMLElement);
                    Utilities.stopEvent(event);
                    return false;
                  }
                },
                children: [
                  Utilities.getIconElement('chevron_right', 'expand or collapse menu item', `xpt-flyout-node-expand-btn-${menu.id}`)
                ]
              })
            ]
          }));
        }

        let treeItemChildren = [Utilities.createElement({ classes: ['xpt-flyout-menu-item'], children: menuItemChildren })];

        if (menu.childItems) {
          treeItemChildren = treeItemChildren.concat(menuToListElement(menu.childItems));
        }

        return Utilities.createElement({
          tag: 'li', attributes, children: [
            Utilities.createElement({ classes: ['xpt-flyout-tree-item'], children: treeItemChildren })
          ]
        });
      })
    });
  }

  function countChildren(menu: Navigation.Menu) {
    let count = 0;
    if (menu && menu.childItems) {
      count += menu.childItems.length;

      menu.childItems.forEach((item) => {
        const subMenu = item as Navigation.Menu;
        if (subMenu) {
          count += countChildren(subMenu);
        }
      });
    }
    return count;
  }
}
